import * as React from 'react';
import {SFC} from 'react';
import {HashRouter, Redirect, Switch, Route} from 'react-router-dom';
import {JobsContainer} from '../jobs/jobs';

export const JobsRouter: SFC = () => (
  <HashRouter>
    <Switch>
      <Route path={'/jobs'} exact component={JobsContainer} />
      <Route path={'/jobs/:jobId'} exact component={JobsContainer} />
      <Redirect from={'*'} to={'/jobs'} />
    </Switch>
  </HashRouter>
);
